<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">
                <div class="form-group col-sm-8">
                  <ul class="navbar-nav overflow-auto flex-row gap-4 pt-1">
                    <li v-for="(statuses, tab) in tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                      <a v-if="tab === 'dispute'" href="#" @click.prevent="onTabSelect(tab)" class="nav-link tab  text-capitalize-first position-relative" :class="{'active': activeTabName === tab}">
                        {{ helper.trans(`deals.tab.${tab}`) }}
                        <span v-if="newDisputeDealsCountOut > 0" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle ms-1 mt-1"></span>
                      </a>
                      <a v-else href="#" @click.prevent="onTabSelect(tab)" class="nav-link tab text-capitalize-first" :class="{'active': activeTabName === tab}">
                        {{ helper.trans(`deals.tab.${tab}`) }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div v-if="activeTabName === 'dispute' && (isAdmin || isOperator)" class="form-group col-sm-8 mt-1">
                  <ul class="navbar-nav overflow-auto flex-row gap-4 pt-1">
                    <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="onDisputeRoleSelect(null)" class="nav-link tab text-capitalize-first" :class="{'active': activeDisputeTab === null}">
                        {{ helper.trans('labels.all') }}
                      </a>
                    </li>
                    <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="onDisputeRoleSelect('Trader')" class="nav-link tab text-capitalize-first" :class="{'active': activeDisputeTab === 'Trader'}">
                        {{ helper.trans('deals.tab.disputeTrader') }}
                      </a>
                    </li>
                    <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="onDisputeRoleSelect('Provider')" class="nav-link tab text-capitalize-first" :class="{'active': activeDisputeTab === 'Provider'}">
                        {{ helper.trans('deals.tab.disputeProvider') }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div v-else class="form-group col-sm-8 mt-1">
                  <ul class="navbar-nav overflow-auto flex-row gap-4 pt-1">
                    <li  v-for="tab in typeTabs" :key="tab" :class="{'d-none': tab === Direction.PAY_OUT && (isTrader && user.pcId)}" class="nav-item nav-item-spaced d-flex text-nowrap" >
                      <a href="#" @click.prevent="onTypeSelect(tab)" class="nav-link tab text-capitalize-first position-relative" :class="{'active': activeTypeName === tab}">
                        {{ helper.trans(`direction.${tab}`) }}
                        <span v-if="tab === Direction.PAY_IN && newActiveDealsCountIn > 0 || tab === Direction.PAY_OUT && newActiveDealsCountOut > 0" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle ms-1 mt-1"></span>
                      </a>
                      <a @click.prevent="showPayoutSettings" class="ms-3 text-secondary" href="#" v-if="tab === Direction.PAY_OUT && (isTrader && !user.pcId || isTraderOperator)"><i class="fa fa-gear"></i></a>
                    </li>
                  </ul>
                </div>

                <div class="form-group col-sm-4 d-flex align-items-center justify-content-end">
                  <!-- Toggle switch for auto-refresh -->
                  <div class="form-check form-switch me-2" v-if="activeTabName === 'active' && isTrader">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="autoRefreshToggle"
                        v-model="autoRefresh"
                        @change="toggleAutoRefresh"
                        v-b-tooltip.hover.left :title="`${helper.trans(autoRefresh ? 'labels.auto_refresh.on' : 'labels.auto_refresh.off')}`"
                    />
                  </div>
                  <button
                      type="button"
                      @click.prevent="toggleFiltersVisibility()"
                      class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  >
                    {{ helper.trans('button.filters') }}
                  </button>
                </div>
              </div>
              <div v-if="showFilters" class="row mt-3">
                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" placeholder="ID" v-model="requestDTO.id">
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="types"
                                   class="multiselect-sm"
                                   v-model="requestDTO.types"
                                   :options="Object.values(Direction)"
                                   :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.type')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.from_sum')" v-model="requestDTO.fromTakerSum">
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.to_sum')" v-model="requestDTO.toTakerSum">
                    </div>
                  </div>
                </div>


                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currencies"
                                   class="multiselect-sm"
                                   v-model="requestDTO.currencies"
                                   :options="currencyList"
                                   :custom-label="(opt) => `${opt}`"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currencies')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isAdmin || isOperator || (isTrader && !user.pcId) || isTraderOperator" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2 d-flex">
                  <div class="col p-0 d-flex align-items-center">
                    <div class="form-check small mb-0">
                      <input class="form-check-input" v-model="requestDTO.roundedToTakerSum" true-value="1000"  type="checkbox" value="" id="roundedToTakerSum">
                      <label class="form-check-label" for="roundedToTakerSum">
                        {{ helper.trans('labels.rounded_to_1000')}}
                      </label>
                    </div>
                  </div>
                </div>


                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="methods"
                                   class="multiselect-sm"
                                   v-model="requestDTO.methods"
                                   :options="methodList()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_methods')"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isAdmin || isOperator || (isTrader && !user.pcId) || isTraderOperator" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2 d-flex">
                  <div class="col p-0 d-flex align-items-center">
                    <div class="form-check small mb-0">
                      <input class="form-check-input" v-model="requestDTO.onlyMir" true-value="y"  type="checkbox" value="" id="onlyMir">
                      <label class="form-check-label" for="onlyMir">
                        {{ helper.trans('labels.only_mir_cards')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.customer_id')" v-model="requestDTO.takerId">
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-4">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(DealStatus)"
                                   :custom-label="(opt) => helper.trans(`deal_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.statuses')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect @update:model-value="onTraderListUpdate" :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div  v-if="!isReferral && (!user.pcId)" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DevicesMultiselect ref="deviceMultiselect" :multiple="true" :trader-ids="tradersFilter.map((item) => item.id)" v-model="devicesFilter">
                      </DevicesMultiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin || isReferral" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <StoreMultiselect :multiple="true" v-model="storesFilter">
                      </StoreMultiselect>
                    </div>
                  </div>
                </div>
                <div v-if="isAdmin" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                      </TrafficGroupMultiselect>
                    </div>
                  </div>
                </div>

                <div v-if="(isAdmin || isOperator)" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        @keydown.enter="() => applyFilters()"
                        :placeholder="helper.trans('labels.sanitized_requisite')"
                        v-model="requestDTO.requisites"
                      >
                    </div>
                  </div>
                </div>

                <div v-if="!isReferral && (!user.pcId)" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0  mt-1">
                      <input class="form-check-input" v-model="requestDTO.hasDisputeRequest" true-value="y"  type="checkbox" value="" id="hasDisputeRequest">
                      <label class="form-check-label" for="hasDisputeRequest">
                        {{ helper.trans('labels.has_dispute')}}
                      </label>
                    </div>
                  </div>
                </div>


                <div v-if="(isAdmin || isOperator) && activeTabName === 'dispute'" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0  mt-1">
                      <input class="form-check-input" v-model="requestDTO.disputePaused" true-value="y"  type="checkbox" value="" id="disputePaused">
                      <label class="form-check-label" for="disputePaused">
                        {{ helper.trans('labels.dispute_paused')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => onTabSelect('active')" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <TraderPayoutLimitBanner
              v-if="currentType === Direction.PAY_OUT && payoutLimit"
              :limit="payoutLimit"
          />

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first" style="width: 0;"></th>
                    <th class="text-capitalize-first">
                      {{ helper.trans('labels.id_date') }}
                      <a v-if="activeTabName === 'dispute' && (isOperator || isAdmin)" href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'createdAt'); loadDeals()">
                        <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'createdAt')" ></i>
                      </a>
                    </th>
                    <th class="text-capitalize-first">
                      {{ helper.trans('labels.status') }}
                      <a v-if="activeTabName === 'dispute' && (isOperator || isAdmin)" href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'updatedAt'); loadDeals()">
                        <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'updatedAt')" ></i>
                      </a>
                    </th>
                    <th class="text-capitalize-first">{{ helper.trans(showStoreRate ? 'labels.trader_rate_merchant_rate' : 'labels.rate') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.requisites') }}</th>
                    <th style="width: 0;"></th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.time_spent_create_deal') }}</th>
                    <th v-if="isOperator || isAdmin || isTeamLead" class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th v-if="isOperator || isAdmin || isReferral" class="text-capitalize-first">{{ helper.trans('labels.store') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="deal in filteredDeals" :key="deal.id" class="">
                    <td class="pe-0">
                      <i v-if="deal.type === Direction.PAY_IN" v-b-tooltip.hover :title="helper.trans(`direction.${deal.type}`)" class="fa-regular fa-circle-down text-primary"></i>
                      <i v-else v-b-tooltip.hover :title="helper.trans(`direction.${deal.type}`)" class="fa-regular fa-circle-up text-warning"></i>
                    </td>
                    <td>
                      <div class="d-flex flex-column mt-1 mb-1">
                        <span v-if="isProvider">
                          <span v-b-tooltip.hover :title="deal.id">{{ deal.id.substring(0, 8) }}</span> <copy-button :value="deal.id"></copy-button>
                        </span>
                        <span v-else>
                          <span v-if="deal.status !== 'rejected'">
                            <span v-b-tooltip.hover :title="deal.publicId">{{ deal.publicId }}</span> <copy-button :value="deal.publicId"></copy-button>
                          </span>
                          <span v-if="(isAdmin || isOperator) && deal.id != deal.invoiceId">
                            / <span v-b-tooltip.hover :title="deal.id">{{ deal.id.substring(0, 8) }}</span> <copy-button :value="deal.id"></copy-button>
                          </span>
                        </span>
                        <small class="text-secondary" v-if="isAdmin || isOperator">
                          <span v-b-tooltip.hover :title="deal.invoiceId">{{ deal.invoiceId.substring(0, 8) }}</span> <copy-button :value="deal.invoiceId"></copy-button>
                          <span v-if="deal.invoiceInternalId"> / <span v-b-tooltip.hover :title="deal.invoiceInternalId">{{ deal.invoiceInternalId.substring(0, 8) }}</span> <copy-button :value="deal.invoiceInternalId"></copy-button>
                          </span>
                        </small>
                        <small class="text-secondary" v-if="deal.aggregatorExternalId && (isAdmin || isOperator || isProvider)">
                          <span v-b-tooltip.hover :title="deal.aggregatorExternalId">{{ deal.aggregatorExternalId.substring(0, 8) }}</span> <copy-button :value="deal.aggregatorExternalId"></copy-button>
                        </small>
                        <small class="text-secondary">{{ dateHelper.format(deal.createdAt) }}</small>
                      </div>
                    </td>
                    <td :class="{'text-primary': deal.status === DealStatus.TRANSFER_CONFIRMED}">
                      <div>
                        <div>
                          {{ helper.trans(`deal_status.${deal.status}`) }} <i v-if="deal.isDisputeAutocompletingSuspend" class="fa fa-pause-circle text-warning me-1"></i>
                          <span class="text-nowrap text-capitalize" v-if="[DealStatus.NEW, DealStatus.TRANSFER_CONFIRMED, DealStatus.TRANSFER_WAITING].includes(deal.status)"><i class="fa fa-stopwatch"></i> {{ getFormattedCancelTime(deal) }}</span>
                          <span class="text-nowrap text-capitalize" v-else-if="deal.disputeAutocloseAt && DealStatus.DISPUTE === deal.status"><i class="fa fa-stopwatch"></i> {{ getFormattedDisputeAutocloseTime(deal) }}</span>
                          <a v-if="deal.disputeAttachment" :href="`${api.baseUrl()}/attachments/${deal.disputeAttachment}`" target="_blank" type="button" class="me-2 text-warning"><i class="fa fa-paperclip"></i></a>
                          <template v-for="attachment in deal.attachments" :key="attachment.id">
                            <a :href="`${api.baseUrl()}/attachments/${attachment.file}`" target="_blank" type="button" class="me-2 text-warning"><i class="fa fa-paperclip"></i></a>
                            <small v-if="chequeCheckerEnabled && receiptVerdict(deal, attachment.id)" class="me-2">{{ receiptVerdict(deal, attachment.id) }}</small>
                            <button
                              v-if="canCheckReceipt && isPdfAttachment(attachment.file)"
                              type="button"
                              class="btn btn-sm btn-outline-secondary text-nowrap me-2"
                              :disabled="isReceiptCheckPending(deal, attachment.id)"
                              v-b-tooltip.hover
                              :title="receiptCheckTooltip(deal, attachment.id)"
                              @click.prevent="checkReceipt(deal, attachment.id)"
                            >{{ helper.trans('button.check_receipt') }}</button>
                            <small v-if="receiptCheckError(deal, attachment.id)" class="text-danger me-2">{{ receiptCheckError(deal, attachment.id) }}</small>
                          </template>
                        </div>
                        <small v-if="deal.disputeReason === DisputeReason.INVALID_SUM || deal.disputeReason === DisputeReason.PART_PAYOUT" class="text-danger">
                        (<span class="text-lowercase">{{ helper.trans(`dispute_reason.${deal.disputeReason}`) }} </span>: {{numberFormatter.formatNumber(deal.disputeReasonData.amount, 2)}} {{deal.takerSum.currency}})
                        </small>
                        <ReceiptCheckStatus v-else-if="isPayOutReceiptCheck(deal.type, deal.disputeReason)" :reason="deal.disputeReason" :data="deal.disputeReasonData"></ReceiptCheckStatus>
                        <small v-else-if="deal.disputeReason" class="text-lowercase text-danger">
                        ({{ helper.trans(`dispute_reason.${deal.disputeReason}`)}})
                        </small>
                        <div v-if="deal._insufficientSumForDisputeClose" class="text-danger">
                          <small ><i class="fa fa-warning"></i> {{helper.trans('labels.insufficientSumForDisputeClose')}}</small>
                        </div>
                        <div v-if="deal.transactionId" class="mt-1">
                          <small class="text-secondary">{{ helper.trans('labels.transaction') }}: <span v-b-tooltip.hover :title="deal.transactionId">{{ deal.transactionId.length > 8 ? deal.transactionId.substring(0, 4) + '...' + deal.transactionId.substring(deal.transactionId.length - 4) : deal.transactionId }}</span> <copy-button :value="deal.transactionId"></copy-button></small>
                        </div>
                        <div v-if="deal.externalNspkTransaction" class="mt-1">
                          <small class="text-secondary">{{ deal.externalNspkTransaction?.service }}: {{deal.externalNspkTransaction?.status}}</small>
                        </div>
                      </div>
                      <div v-if="deal.disputeResult">
                        <small class="text-lowercase text-primary">
                          {{ helper.trans(`dispute_result.${deal.disputeResult}`) }}
                        </small>
                      </div>
                      <div>
                        <small class="text-secondary">{{ dateHelper.format(deal.updatedAt) }}</small>
                      </div>
                    </td>
                    <td>
                      <span v-if="deal.status !== 'rejected'">
                        {{ numberFormatter.formatNumber(deal.takerSum.amount / deal.makerSum.amount, deal.takerSum.subunit) }}<template v-if="deal.merchantMakerSum"> / {{ numberFormatter.formatNumber(deal.takerSum.amount / deal.merchantMakerSum.amount, deal.takerSum.subunit) }}</template> {{ deal.takerSum.currency }}
                      </span>
                    </td>
                    <td>
                      <div v-if="deal.actualTakerSum">
                        <div>
                          {{ numberFormatter.formatMoney(deal.actualTakerSum) }}
                          <copy-button :value="deal.actualTakerSum.amount"></copy-button>
                        </div>
                      </div>
                      <div v-if="!deal.actualTakerSum || deal.isActualSumsChanged" :class="{'text-decoration-line-through': deal.isActualSumsChanged}">
                        {{ numberFormatter.formatMoney(deal.takerSum) }}
                      <copy-button :value="deal.takerSum.amount"></copy-button>
                      </div>
                      <div v-if="deal.actualMakerSum" class="small  text-secondary">
                        {{ numberFormatter.formatMoney(deal.actualMakerSum) }}
                        <copy-button :value="deal.actualMakerSum.amount"></copy-button>
                      </div>
                      <div v-if="deal.status !== 'rejected' && (!deal.actualMakerSum || deal.isActualSumsChanged)" class="small text-secondary" :class="{'text-decoration-line-through': deal.isActualSumsChanged}">
                        {{ numberFormatter.formatMoney(deal.makerSum) }}
                        <copy-button :value="deal.makerSum.amount"></copy-button>
                      </div>
                      <div v-if="deal.strictlySingleTransfer === true">
                        <small class="text-danger"><i class="fa fa-warning"></i> {{ helper.trans('labels.strictly_single_transfer')}}</small>
                      </div>
                      <div v-if="deal.type === Direction.PAY_OUT && !hidePayoutSupportedMethods">
                        <small class="text-danger" v-if="!payOutDocLink">
                          <i class="fa fa-warning"></i> {{ helper.trans('labels.pay_out_supported_methods_sources_start')}}
                          <span style="border-bottom: 1px dashed" v-b-tooltip.hover :title="payOutSupportedMethodsSources.map((method) => helper.trans(`pay_methods.${method}`)).join(', ')">{{ helper.trans('labels.pay_out_supported_methods_sources_end', {count: payOutSupportedMethodsSources.length})}}</span>
                        </small>
                        <small class="text-danger" v-else>
                          <i class="fa fa-warning"></i> <a :href="payOutDocLink" class="text-danger" target="_blank">{{ helper.trans('labels.pay_out_supported_methods_doc_link')}}</a>
                        </small>
                      </div>
                      <div v-if="deal.minTakerSum && deal.maxTakerSum || deal.minInTakerSum && deal.maxInTakerSum" class="mt-1 small">
                        <div v-if="deal.minTakerSum && deal.maxTakerSum">
                          <small v-if="deal.minTakerSum?.amount !== deal.maxTakerSum?.amount" class="text-secondary">{{ numberFormatter.formatMoney(deal.minTakerSum) }} - {{ numberFormatter.formatMoney(deal.maxTakerSum) }}</small>
                          <small v-else class="text-secondary">{{ numberFormatter.formatMoney(deal.minTakerSum) }}</small>
                        </div>

                        <div v-if="deal.minInTakerSum && deal.maxInTakerSum">
                          <small v-if="deal.minInTakerSum?.amount !== deal.maxInTakerSum?.amount" class="text-secondary">{{ numberFormatter.formatMoney(deal.minInTakerSum) }} - {{ numberFormatter.formatMoney(deal.maxInTakerSum) }}</small>
                          <small v-else class="text-secondary">{{ numberFormatter.formatMoney(deal.minInTakerSum) }}</small>
                        </div>

                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                      <div class="d-flex flex-row align-items-center gap-2">
                        <PayMethodIcon :method="deal.paymentMethod"></PayMethodIcon>
                        <div class="d-flex flex-column">
                          <small class="d-flex gap-1">
                            <span>{{ helper.trans('payment_options.' + deal.paymentOption) }}</span>
                            <span v-if="deal.requisites?.crossBorderCurrency">{{deal.requisites?.crossBorderCurrency}}</span>
                            <span v-if="deal.requisites?.paymentSystem">{{ helper.trans('payment_systems.' + deal.requisites?.paymentSystem) }}</span>
                            <span v-if="deal.requisites?.p2cConfig?.service_name">{{ helper.trans(`multitransfer.service.${deal.requisites?.p2cConfig?.service_name}`) }}</span>
                            <span v-if="deal.matchingPayoutDeal" style="line-height: 10px" class="badge bg-primary">Matching</span>
                          </small>
                          <div v-if="deal.type === Direction.PAY_OUT && deal.status === DealStatus.NEW">
                            <small class="text-secondary text-wrap">{{ helper.trans('labels.accept_deal_to_show_req')}}</small>
                          </div>
                          <div v-else class="d-flex flex-column">
                            <span v-if="(deal.type === Direction.PAY_OUT && deal.paymentOption === PaymentOption.TO_CARD) || deal.paymentOption === PaymentOption.MANUAL_ECOM">
                              {{ deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim() }}
                              <copy-button :value="deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()"></copy-button>
                            </span>
                            <small v-else-if="deal.paymentOption === PaymentOption.MANUAL_SBP_QR && !helper.dealQrCodeLink(deal)" class="text-secondary">{{ helper.trans('labels.manual_sbp_qr_awaiting_link') }}</small>
                            <span v-else-if="!helper.isEmvQrOption(deal.paymentOption) && (!!deal.paymentRequisites.requisites || (deal.paymentOption === PaymentOption.MANUAL_SBP_QR && helper.dealQrCodeLink(deal)))">
                              <a v-if="deal.paymentOption === PaymentOption.SBP_QR && deal.paymentRequisites.requisites?.startsWith('http')" :href="deal.paymentRequisites.requisites" target="_blank">{{ helper.domain(deal.paymentRequisites.requisites) }}</a>
                              <a v-else-if="deal.paymentOption === PaymentOption.MANUAL_SBP_QR && helper.dealQrCodeLink(deal)" :href="helper.dealQrCodeLink(deal)" target="_blank">{{ helper.domain(helper.dealQrCodeLink(deal)) }}</a>
                              <a v-else-if="deal.paymentOption === PaymentOption.CLICK_UZ_QR && deal.paymentRequisites.requisites?.startsWith('http')" :href="deal.paymentRequisites.requisites" target="_blank">{{ helper.trans('labels.my_click_uz') }}</a>
                              <a v-else-if="deal.paymentOption === PaymentOption.TIPS && deal.paymentRequisites.requisites?.startsWith('http')" :href="deal.paymentRequisites.requisites" target="_blank">{{ helper.domain(deal.paymentRequisites.requisites) }}</a>
                              <a v-else-if="deal.paymentRequisites.requisites?.startsWith('http')" :href="deal.paymentRequisites.requisites" target="_blank">{{ helper.domain(deal.paymentRequisites.requisites) }}</a>
                              <span v-else>{{ deal.paymentRequisites.requisites }}</span>
                              <copy-button :value="deal.paymentOption === PaymentOption.MANUAL_SBP_QR && helper.dealQrCodeLink(deal) ? helper.dealQrCodeLink(deal) : deal.paymentRequisites.requisites" class="ms-1"></copy-button>
                            </span>
                            <span v-if="helper.isEmvQrOption(deal.paymentOption)">
                              <small class="text-secondary text-capitalize-first me-2">{{ helper.trans('labels.raw_field.qrString') }}</small>
                              <copy-button :value="helper.emvQrData(deal)"></copy-button>
                            </span>
                            <small v-if="deal.paymentOption === PaymentOption.SBP_QR && deal.requisites && !deal.requisites.requisites.startsWith('http')" class="text-secondary">{{ deal.requisites.requisites }}</small>
                            <small v-else class="text-secondary"> {{ deal.paymentRequisites.holder }}</small>
                          </div>
                        </div>
                      </div>
                      <div v-if="deal.matchingPayoutDeal && deal.type === Direction.PAY_OUT" class="d-flex flex-column">
                        <div>
                           <span class="mb-2" v-b-tooltip.hover :title="helper.trans('labels.day')">
                          <b-progress :max="parseInt(deal.matchingPayoutDeal.dealsSumLimit.amount)" class="progress-bar-striped position-relative">
                            <b-progress-bar :value="parseInt(deal.matchingPayoutDeal.dealsSum.amount)" class="progress-bar-striped bg-secondary-light position-absolute h-100"></b-progress-bar>
                            <b-progress-bar :value="parseInt(deal.matchingPayoutDeal.completedDealsSum.amount)" class="progress-bar-striped bg-primary position-absolute h-100"></b-progress-bar>
                            <small class="justify-content-center d-flex position-absolute w-100">{{ numberFormatter.formatNumber(deal.matchingPayoutDeal?.completedDealsSum) }}/{{ numberFormatter.formatNumber(deal.matchingPayoutDeal?.dealsSumLimit) }}</small>
                          </b-progress>
                        </span>
                        </div>
                      </div>
                        <div v-if="deal.matchingPayoutDeal && deal.type === Direction.PAY_IN">
                          <span>{{helper.trans(`direction.out`) }}:</span> <span v-b-tooltip.hover :title="deal.matchingPayoutDeal.dealId">{{ deal.matchingPayoutDeal.dealId.substring(0, 8) }}</span> <copy-button :value="deal.matchingPayoutDeal.dealId"></copy-button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <DeviceLabel :show-id="isOperator || isAdmin" v-if="deal.type === Direction.PAY_IN && deal._device" :device="deal._device" @device:updated="onDeviceUpdated"></DeviceLabel>
                    </td>
                    <td>
                      <span v-if="deal.timeSpentCreateDeal != null">{{ numberFormatter.formatNumber(deal.timeSpentCreateDeal, 3) }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td v-if="isOperator || isAdmin || isTeamLead">
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center">
                          <span>
                            {{deal.traderName }}
                          </span>
                          <span v-if="providersByTraderId[deal.traderId]" v-b-tooltip.hover :title="helper.trans('labels.provider')" class="badge bg-warning ms-1">P</span>

                        </div>
                        <small v-if="isOperator || isAdmin" class="text-secondary"> {{ deal.traderId ?? 'n/a' }} <copy-button v-if="deal.traderId" :value="deal.traderId.toString()"></copy-button></small>
                        <small v-if="providersByTraderId[deal.traderId]?.supportApiDisputes" class="text-primary"><i class="fa fa-circle-info"></i>
                          {{helper.trans('labels.api_disputes')}}
                        </small>
                      </div>
                    </td>
                    <td v-if="isOperator || isAdmin || isReferral">
                      <div class="d-flex flex-row">
                        <small class="text-secondary me-1">{{ deal.merchantId ?? 'n/a' }} <copy-button v-if="deal.merchantId" :value="deal.merchantId.toString()"></copy-button></small>
                        {{ deal.merchantName }}
                      </div>
                      <div class="d-flex flex-row">
                        <small class="text-secondary me-1">{{ deal.storeId ?? 'n/a' }} <copy-button v-if="deal.storeId" :value="deal.storeId.toString()"></copy-button></small>
                        {{ deal.storeName }}
                      </div>
                    </td>
                    <td class="text-end" v-if="(isTrader || isTraderOperator) && deal.type === Direction.PAY_OUT ">
                      <button type="button" @click="detailsDeal = deal" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa fa-list"></i></button>
                      <button @click.prevent="changeStatus(deal, 'refuse')" v-if="deal.status === DealStatus.TRANSFER_WAITING || deal.status === DealStatus.DISPUTE" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-cancel"></i> {{ helper.trans('button.refuse') }}</button>
                      <button @click.prevent="changeStatus(deal, 'dispute')" v-if="canShowActiveDealDisputeButton(deal)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa-regular fa-comments"></i> {{ helper.trans('button.open_dispute') }}</button>
                      <button @click.prevent="changeStatus(deal, 'accept')" v-if="deal.status === DealStatus.NEW && !isExpired(deal)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-stopwatch"></i> {{ getFormattedCancelTime(deal) }} {{ helper.trans('button.accept') }}</button>
                      <button @click.prevent="changeStatus(deal, 'confirm_payout')" v-if="user.isPayoutConfirmationFromWebAppAllowed && (deal.status === DealStatus.TRANSFER_WAITING || deal.status === DealStatus.DISPUTE)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.confirm_transfer') }}</button>
                      <button @click.prevent="requestVideo(deal)" v-if="deal.isVideoRequestAvailable" :disabled="isVideoRequested(deal)" v-b-tooltip.hover :title="isVideoRequested(deal) ? dateHelper.format(deal.videoRequestedUntil) : null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-video"></i> {{ isVideoRequested(deal) ? helper.trans('button.video_requested') : helper.trans('button.request_video') }}</button>
                    </td>
                    <td class="text-end" v-if="(isOperator || isAdmin) && deal.type === Direction.PAY_OUT">
                      <button v-if="(isAdmin || (isOperator && store.getters.hasPermission(UserPermission.REDIRECT_PAYOUTS))) && deal.status === DealStatus.DISPUTE" type="button" @click="assignTrader(deal)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa-solid fa-user-pen"></i></button>
                      <button v-if="(isAdmin || (isOperator && store.getters.hasPermission(UserPermission.REDIRECT_PAYOUTS))) && deal.status === DealStatus.NEW && deal.traderId === null" type="button" @click="assignByUnassigned(deal)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa-solid fa-user-pen"></i></button>
                      <button type="button" @click="detailsDeal = deal" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa fa-list"></i></button>
                      <button @click.prevent="changeStatus(deal, 'accept')" v-if="deal.status === DealStatus.NEW && deal.traderId !== null && !isExpired(deal)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.accept') }}</button>
                      <button @click.prevent="changeStatus(deal, 'cancel')" v-if="[DealStatus.NEW, DealStatus.TRANSFER_WAITING, DealStatus.DISPUTE].includes(deal.status)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-cancel"></i> {{ helper.trans('button.cancel') }}</button>
                      <button @click.prevent="changeStatus(deal, 'dispute')" v-if="canShowActiveDealDisputeButton(deal)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa-regular fa-comments"></i> {{ helper.trans('button.open_dispute') }}</button>
                      <button @click.prevent="showChangeAmount(deal)" v-if="canChangePayOutAmount(deal)" type="button" class="me-2 btn btn-sm btn-outline-primary text-nowrap text-capitalize"><i class="fa fa-pen"></i> {{ helper.trans('button.change_payout_amount') }}</button>
                      <button @click.prevent="changeStatus(deal, 'confirm')" v-if="[DealStatus.TRANSFER_WAITING, DealStatus.DISPUTE].includes(deal.status)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.confirm_transfer') }}</button>
                      <button @click.prevent="changeStatus(deal, 'dispute')" v-if="deal.status === DealStatus.CANCELED || deal.status === DealStatus.COMPLETED" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa-regular fa-comments"></i> {{ helper.trans('button.open_dispute') }}</button>
                      <button @click.prevent="requestVideo(deal)" v-if="deal.isVideoRequestAvailable" :disabled="isVideoRequested(deal)" v-b-tooltip.hover :title="isVideoRequested(deal) ? dateHelper.format(deal.videoRequestedUntil) : null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-video"></i> {{ isVideoRequested(deal) ? helper.trans('button.video_requested') : helper.trans('button.request_video') }}</button>
                      <a :href="`${api.baseUrl()}/attachments/${deal.disputeAttachment}`" target="_blank" v-if="deal.status === DealStatus.DISPUTE && deal.disputeAttachment !== null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap"><i class="fa fa-paperclip"></i></a>
                    </td>
                    <td class="text-end" v-if="(isTrader || isTraderOperator) && deal.type === Direction.PAY_IN ">
                      <button type="button" @click="detailsDeal = deal" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa fa-list"></i></button>
                      <button @click.prevent="changeStatus(deal, 'accept')" v-if="deal.status === DealStatus.NEW" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.accept') }}</button>
                      <button @click.prevent="changeStatus(deal, 'cancel')" v-if="deal.status === DealStatus.NEW" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-cancel"></i> {{ helper.trans('button.cancel') }}</button>
                      <button @click.prevent="changeStatus(deal, 'confirm')" v-if="[DealStatus.DISPUTE, DealStatus.TRANSFER_CONFIRMED, DealStatus.TRANSFER_WAITING, DealStatus.CANCELED].includes(deal.status)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.confirm_transfer') }}</button>
                      <button @click.prevent="requestVideo(deal)" v-if="deal.isVideoRequestAvailable" :disabled="isVideoRequested(deal)" v-b-tooltip.hover :title="isVideoRequested(deal) ? dateHelper.format(deal.videoRequestedUntil) : null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-video"></i> {{ isVideoRequested(deal) ? helper.trans('button.video_requested') : helper.trans('button.request_video') }}</button>
                      <a :href="`${api.baseUrl()}/attachments/${deal.disputeAttachment}`" target="_blank" v-if="deal.status === DealStatus.DISPUTE && deal.disputeAttachment !== null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap"><i class="fa fa-paperclip"></i></a>
                    </td>
                    <td class="text-end" v-if="(isOperator || isAdmin) && deal.type === Direction.PAY_IN">
                      <button type="button" v-if="deal.status === DealStatus.DISPUTE && deal.isDisputeAutocompletingSuspend !== true" @click="showSuspendDealModal(deal)" class="btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2"><i class="fa fa-pause-circle"></i></button>
                      <button v-b-tooltip.hover :title="getSuspendDisputeTitle(deal)" type="button" v-else-if="deal.status === DealStatus.DISPUTE && deal.isDisputeAutocompletingSuspend === true" @click="dealAutocompleting(deal, 'resume')" class="btn btn-sm btn-outline-success text-nowrap text-capitalize me-2"><i class="fa fa-play-circle"></i></button>

                      <button v-if="deal.deviceId" type="button" @click="showMessageLogs(deal)" class="btn btn-sm btn-outline-secondary text-nowrap me-2"><i class="fa fa-mobile-screen-button"></i> <i class="fa-regular fa-comments"></i></button>
                      <button type="button" @click="detailsDeal = deal" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa fa-list"></i></button>
                      <button @click.prevent="changeStatus(deal, 'cancel')" v-if="deal.status === DealStatus.DISPUTE || ([DealStatus.TRANSFER_WAITING, DealStatus.TRANSFER_CONFIRMED].includes(deal.status) && enableOperatorPayInCancelTransferWaiting)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-cancel"></i> {{ helper.trans('button.cancel') }}</button>
                      <button @click.prevent="changeStatus(deal, 'dispute')" v-if="canShowActiveDealDisputeButton(deal)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa-regular fa-comments"></i> {{ helper.trans('button.open_dispute') }}</button>
                      <button @click.prevent="changeStatus(deal, 'confirm')" v-if="deal.status === DealStatus.DISPUTE || ([DealStatus.TRANSFER_WAITING, DealStatus.TRANSFER_CONFIRMED].includes(deal.status) && enableOperatorPayInConfirmTransferWaiting)" type="button" class="me-2 btn btn-sm btn-outline-success text-nowrap text-capitalize"><i class="fa fa-check"></i> {{ helper.trans('button.confirm_transfer') }}</button>
                      <button @click.prevent="changeStatus(deal, 'dispute')" v-if="canShowPayInDisputeButton(deal)" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa-regular fa-comments"></i> {{ helper.trans('button.open_dispute') }}</button>
                      <button @click.prevent="requestVideo(deal)" v-if="deal.isVideoRequestAvailable" :disabled="isVideoRequested(deal)" v-b-tooltip.hover :title="isVideoRequested(deal) ? dateHelper.format(deal.videoRequestedUntil) : null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"><i class="fa fa-video"></i> {{ isVideoRequested(deal) ? helper.trans('button.video_requested') : helper.trans('button.request_video') }}</button>
                      <a :href="`${api.baseUrl()}/attachments/${deal.disputeAttachment}`" target="_blank" v-if="deal.status === DealStatus.DISPUTE && deal.disputeAttachment !== null" type="button" class="me-2 btn btn-sm btn-outline-secondary text-nowrap"><i class="fa fa-paperclip"></i></a>
                    </td>
                    <td class="text-end" v-if="isReferral || isTeamLead"></td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="deals.totalCount > deals.items.length"
                  v-model="page"
                  :total-rows="deals.totalCount"
                  :per-page="deals.limit"
                  :limit="20"
                  @update:modelValue="loadDeals()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  last-number
                  hide-goto-end-buttons
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
      <b-modal title=""
               dialog-class="modal-lg"
               :modelValue="detailsDeal !== null"
               footer-class="d-flex justify-content-end"
               @update:modelValue="$event === false && (detailsDeal = null)">
        <template #default>
          <TradeDealDetailsTable v-if="detailsDeal" :deal="detailsDeal" @manual-sbp-qr-updated="onManualSbpQrDealDetailsUpdated"/>
        </template>
        <template #footer>
          <button type="button" @click.prevent="detailsDeal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
            {{ helper.trans('button.ok')  }}
          </button>
        </template>
      </b-modal>

      <b-modal :title="helper.trans('labels.message_logs', {'device_name': logsModalDevice?.name})"
               dialog-class="modal-xl"
               :modelValue="logsModalDevice !== null"
               footer-class="d-flex justify-content-end"
               @update:modelValue="$event === false && (logsModalDevice = null)">
        <template #default>
          <DeviceMessageLogs :from-date="logsModalDates.fromDate" :to-date="logsModalDates.toDate" :device="logsModalDevice!"></DeviceMessageLogs>
        </template>
        <template #footer>
          <button type="button" @click.prevent="logsModalDevice = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
            {{ helper.trans('button.ok')  }}
          </button>
        </template>
      </b-modal>

      <b-modal title=""
               dialog-class="modal-lg"
               :modelValue="payOutSettingsModal"
               footer-class="d-flex justify-content-end"
               @update:modelValue="payOutSettingsModal = $event">
        <template #default>
          <LoaderWrapper ref="payOutSettingsModalLoader">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="row mt-2">
                  <label for="from_sum" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.from_sum") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps">
                      <input :class="parentProps.class" v-model="payOutSettings.minAmount" type="text" class="form-control " id="from_sum">
                    </FormInputWrapper>
                  </div>
                </div>

                <div class="row mt-2">
                  <label for="to_sum" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.to_sum") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps">
                      <input v-model="payOutSettings.maxAmount" :class="parentProps.class"  type="text" class="form-control " id="to_sum">
                    </FormInputWrapper>
                  </div>
                </div>

                <div class="row mt-2">
                  <label for="pay-out-currencies" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currencies") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps">
                      <Multiselect id="pay-out-currencies"
                                   class="multiselect-sm"
                                   v-model="payOutSettings.currencies"
                                   :options="currencyList"
                                   :custom-label="(opt) => `${opt}`"
                                   :multiple="true"
                                   select-label="Select"
                      >
                      </Multiselect>
                    </FormInputWrapper>
                  </div>
                </div>

                <div class="row mt-2">
                  <label class="col-sm-4 col-form-label text-capitalize-first" for="pay-out-roundedToTakerSum">
                    {{ helper.trans('labels.rounded_to_1000')}}
                  </label>
                  <div class="col-sm-8">
                    <div class="form-check form-switch d-flex align-items-center">
                      <input class="form-check-input" v-model="payOutSettings.multiplesOfValue1000"
                             type="checkbox" id="pay-out-roundedToTakerSum">
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <label for="pay-out-methods" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_methods") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps">
                      <Multiselect id="pay-out-methods"
                                   class="multiselect-sm"
                                   v-model="payOutSettings.paymentMethods"
                                   :options="methodList()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :readonly="!isAdmin"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </FormInputWrapper>
                  </div>
                </div>

                <div class="row mt-2">
                  <label for="pay-out-options" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_options") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps">
                      <Multiselect id="pay-out-options"
                                   class="multiselect-sm"
                                   v-model="payOutSettings.paymentOptions"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :readonly="!isAdmin"
                      >
                      </Multiselect>
                    </FormInputWrapper>
                  </div>
                </div>

                <div class="row mt-2">
                  <label for="pay-out-onlyMir" class="col-sm-4 col-form-label text-capitalize-first">
                    {{ helper.trans("labels.only_mir_cards") }}
                  </label>
                  <div class="col-sm-8">
                    <div class="form-check form-switch d-flex align-items-center">
                      <input class="form-check-input" v-model="payOutSettings.onlyMir" :true-value="true"  type="checkbox" value="" id="pay-out-onlyMir">
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-if="isAdmin">
                  <label for="maxActiveDealCount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.max_active_deals_count") }}</label>
                  <div class="col-sm-8">
                    <div class="col-sm-8">
                      <input type="text" class="form-control form-control-sm" v-model="payOutSettings.maxActiveDealsCount" id="maxActiveDealCount">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LoaderWrapper>
        </template>
        <template #footer>
          <button type="button" @click.prevent="payOutSettingsModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">
            {{ helper.trans('button.cancel')  }}
          </button>
          <button type="button" @click.prevent="savePayoutSettings()" class="btn btn-outline-primary btn-sm text-capitalize-first">
            {{ helper.trans('button.save')  }}
          </button>
        </template>
      </b-modal>

      <ConfirmModal ref="confirmModal"></ConfirmModal>
      <DealConfirmModal ref="dealConfirmModal"></DealConfirmModal>
      <DisputeConfirmModal ref="disputeConfirmModal"></DisputeConfirmModal>
      <PayoutConfirmModal ref="payoutConfirmModal"></PayoutConfirmModal>
      <OperatorDealConfirmModal ref="operatorDealConfirmModal"></OperatorDealConfirmModal>
      <SuspendDealModal ref="suspendDealModal"></SuspendDealModal>
      <AssignTraderToDealModal ref="assignTraderToDealModal"></AssignTraderToDealModal>
      <ChangeDealAmountModal ref="changeDealAmountModal"></ChangeDealAmountModal>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import CopyButton from "@/components/CopyButton.vue";
import {computed, defineComponent, onMounted, onUnmounted, reactive, ref, toRefs, watch} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {formatMinutesSeconds} from "@/service/TimeFormatter";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {TransactionType} from "@/models/enum/TransactionType";
import {debounce, helper} from "@/service/CommonHelper";
import TraderDealDTO from "@/models/TraderDealDTO";
import DealRequestDTO from "@/models/request/DealRequestDTO";
import {DealStatus} from "@/models/enum/DealStatus";
import {BModal, BPagination, BPopover} from "bootstrap-vue-3";
import moment from "moment/moment";
import ExtendedDealDTO from "@/models/ExtendedDealDTO";
import {useStore} from "vuex";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import DealConfirmModal, {DealConfirmModalProps} from "@/components/DealConfirmModal.vue";
import DisputeConfirmModal, {DisputeConfirmModalProps} from "@/components/DisputeConfirmModal.vue";
import {DisputeReason, isPayOutReceiptCheck} from "@/models/enum/DisputeReason";
import ReceiptCheckStatus from "@/components/ReceiptCheckStatus.vue";
import OperatorDealConfirmModal, {OperatorDealConfirmModalProps} from "@/components/OperatorDealConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import PaginationDTO from "@/models/PaginationDTO";
import {Direction} from "@/models/enum/Direction";
import {UserPermission} from "@/models/enum/UserPermission";
import PayoutConfirmModal, {PayoutConfirmModalProps} from "@/components/PayoutConfirmModal.vue";
import TradeDealDetailsTable from "@/components/TradeDealDetailsTable.vue";
import DeviceMessageLogs from "@/components/DeviceMessageLogs.vue";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import TraderDTO from "@/models/TraderDTO";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import {Dictionary} from "@/types";
import DeviceLabel from "@/components/DeviceLabel.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import TraderPayoutSettingsDTO, {defaultDto} from "@/models/TraderPayoutSettingsDTO";
import {PaymentOption} from "@/models/enum/PaymentOption";
import OrderByDTO from "@/models/OrderByDTO";
import SuspendDealModal from "@/components/SuspendDealModal.vue";
import AccountDTO from "@/models/AccountDTO";
import AssignTraderToDealModal from "@/components/AssignTraderToDealModal.vue";
import ChangeDealAmountModal from "@/components/ChangeDealAmountModal.vue";
import ProviderDTO from "@/models/ProviderDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import TraderPayoutLimitBanner from "@/components/TraderPayoutLimitBanner.vue";
import {parsePayoutLimitResponse, payoutAcceptHint} from "@/service/PayoutLimitHelper";
import TraderPayoutLimitDTO from "@/models/TraderPayoutLimitDTO";
import {findReceiptCheck, isPdfAttachment, receiptCheckKey, receiptVerdict, upsertReceiptCheck} from "@/service/ReceiptCheckHelper";

const api = new APIClient();
const notification = useNotification()

const typeTabs = [Direction.PAY_IN, Direction.PAY_OUT];

export default defineComponent({
  name: 'Deals',
  methods: {debounce},
  components: {
    ReceiptCheckStatus,
    BPopover,
    FormInputWrapper,
    AssignTraderToDealModal,
    ChangeDealAmountModal,
    SuspendDealModal,
    PayMethodIcon,
    DevicesMultiselect,
    StoreMultiselect,
    TrafficGroupMultiselect,
    TraderMultiselect,
    DeviceMessageLogs,
    TradeDealDetailsTable,
    BModal,
    LoaderWrapper,
    CopyButton,
    BPagination,
    Multiselect,
    DatePicker,
    ConfirmModal,
    DealConfirmModal,
    DisputeConfirmModal,
    OperatorDealConfirmModal,
    PayoutConfirmModal,
    DeviceLabel,
    TraderPayoutLimitBanner,
  },
  setup() {
    const store = useStore();
    helper.initCopyHints();

    let tabs = {
      active: [DealStatus.NEW, DealStatus.TRANSFER_CONFIRMED, DealStatus.TRANSFER_WAITING],
      completed: [DealStatus.COMPLETED],
      canceled: [DealStatus.CANCELED],
      dispute: [DealStatus.DISPUTE],
    } as any

    if (store.getters.getAppData?.canViewRejectedDeals) {
      tabs.rejected = ['rejected']
    }

    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const changeDealAmountModal = ref<InstanceType<typeof ChangeDealAmountModal> | null>(null)
    const dealConfirmModal = ref<InstanceType<typeof DealConfirmModal> | null>(null)
    const disputeConfirmModal = ref<InstanceType<typeof DisputeConfirmModal> | null>(null)
    const payoutConfirmModal = ref<InstanceType<typeof PayoutConfirmModal> | null>(null)
    const operatorDealConfirmModal = ref<InstanceType<typeof OperatorDealConfirmModal> | null>(null)
    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const payOutSettingsModalLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const deviceMultiselect = ref<InstanceType<typeof DevicesMultiselect> | null>(null)
    const suspendDealModal = ref<InstanceType<typeof SuspendDealModal> | null>(null)
    const assignTraderToDealModal = ref<InstanceType<typeof AssignTraderToDealModal> | null>(null)

    const state = reactive({
      payOutDocLink: '' as string,
      payOutSupportedMethodsSources: [] as string[],
      hidePayoutSupportedMethods: process.env.VUE_APP_HIDE_PAYOUT_SUPPORTED_METHODS === undefined ? 0 : Number(process.env.VUE_APP_HIDE_PAYOUT_SUPPORTED_METHODS),
      tradersFilter: [] as TraderDTO[],
      devicesFilter: [] as TraderDeviceDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      logsModalDates: {} as any,
      logsModalDevice: null as TraderDeviceDTO|null,
      detailsDeal: null as TraderDealDTO|null,
      showFilters: false,
      page: 1,
      payOutSettingsModal: false as boolean,
      currentTimestamp: Date.now(),
      payOutSettings: {
        ...defaultDto
      } as TraderPayoutSettingsDTO,
      payoutLimit: null as TraderPayoutLimitDTO | null,
      orderByDTO: {
        field: 'createdAt',
        direction: 'desc',
      } as OrderByDTO,
      receiptCheckPending: {} as Record<string, boolean>,
      receiptCheckErrors: {} as Record<string, string>,
      requestDTO: {
        id: null,
        takerId: null,
        types: [Direction.PAY_IN],
        statuses: tabs.active,
        fromDate: moment().subtract(1, 'month').format('YYYY-MM-DD 00:00:00'),
        toDate: null,
        updatedFromDate: null,
        fromTakerSum: null,
        toTakerSum: null,
        currencies: [],
        methods: [],
        hasDisputeRequest: null,
        disputePaused: null,
        traderIds: [],
        storeIds: [],
        deviceIds: [],
        trafficGroupsIds: [],
        options: [],
        onlyMir: null,
        roundedToTakerSum: null,
        requisites: null,
        userRole: null
      } as DealRequestDTO,
      currentType: Direction.PAY_IN as Direction,
      activeDisputeTab: null as null|string,
      newActiveDealsCountIn: 0,
      newActiveDealsCountOut: 0,
      newDisputeDealsCountOut: 0,
      lastUpdateTimeIn: moment().utc().format('YYYY-MM-DD HH:mm:ss') as string,
      lastUpdateTimeOut: moment().utc().format('YYYY-MM-DD HH:mm:ss') as string,
      lastUpdateTimeDispute: moment().utc().format('YYYY-MM-DD HH:mm:ss') as string,
      updateTimeInterval: null as any,
      updateCurrentTimeInterval: null as any,
      providersByTraderId: {} as Dictionary<ProviderDTO>,
      deals: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<ExtendedDealDTO>,
      activeTabReloadInterval: 0 as any,
      autoRefresh: false,
    });


    const getSuspendDisputeTitle = (deal: ExtendedDealDTO) => {
      return helper.trans('labels.pause_until', {
        date: dateHelper.format(deal.suspendDisputeAutocloseAt),
        comment: deal.suspendDisputeComment ?? ''
      })
    }

    const showSuspendDealModal = (deal: ExtendedDealDTO) => {
      suspendDealModal.value?.show(deal, async (form: any) => {

        await dealAutocompleting(deal, 'suspend', form)
      })
    }

    const dealAutocompleting = async (deal: TraderDealDTO, action: string, form: any = {}) => {
      pageLoader.value?.show()
      try {
        await api.dealDisputeAutocompleting(deal.id, action, form);
        await loadDeals()
      } finally {
        pageLoader.value?.hide()
      }
    }

    const assignTrader = async (deal: ExtendedDealDTO) => {
      assignTraderToDealModal.value?.show(deal, async (form: any) => {

        pageLoader.value?.show()
        try {
          await api.dealAssignTrader(deal.id, form.trader.id)
          await loadDeals()
        } finally {
          pageLoader.value?.hide()
        }
      })
    }

    const assignByUnassigned = async (deal: ExtendedDealDTO) => {
      assignTraderToDealModal.value?.show(deal, async (form: any) => {

        pageLoader.value?.show()
        try {
          await api.assignTraderByUnassignedDeal(deal.id, form.trader.id)
          await loadDeals()
        } finally {
          pageLoader.value?.hide()
        }
      })
    }

    const changeStatus = async (deal: TraderDealDTO|ExtendedDealDTO, action: string) => {
      const id = deal.id

      if (action === 'confirm_payout') {
        payoutConfirmModal.value?.show({
          okTitle: helper.trans(`deals.action.${action}`),
          cancelTitle: null,
          deal: deal,
          onOkClick: async () => {
            pageLoader.value?.show()
            try {
              const form = payoutConfirmModal.value?.getForm();
              await api.dealChangeStatus(id, 'confirm', form);
              await loadDeals()
            } catch (e) {
              if (helper.isValidationErrors(e)) {
                for (const item of helper.getValidationErrors(e)) {
                  notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
                }
              }
              console.log(e)
              throw e
            } finally {
              pageLoader.value?.hide()
            }
          }
        } as PayoutConfirmModalProps);
        return;
      }

      if (action === 'dispute' || action === 'refuse') {
        disputeConfirmModal.value?.show({
          direction: deal.type,
          deal: deal,
          title: helper.trans('labels.deal_action_confirmation', {action: helper.trans(`deals.action.${action}`)}),
          okTitle: helper.trans(`deals.action.${action}`),
          cancelTitle: null,
          onOkClick: async () => {
            pageLoader.value?.show()
            try {
              const form = disputeConfirmModal.value?.getForm();
              await api.dealChangeStatus(id, action, form);
              await loadDeals()
            } catch (e) {
              if (helper.isValidationErrors(e)) {
                const errors = helper.getValidationErrors(e);
                for (const item of errors) {
                  notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
                }
                disputeConfirmModal.value?.setErrors(errors)
              }

              console.log(e)
              throw e
            } finally {
              pageLoader.value?.hide()
            }
          }
        } as DisputeConfirmModalProps);
        return;
      }

      if (action === 'confirm' && (store.getters.isOperator || store.getters.isAdmin )) {
        operatorDealConfirmModal.value?.show({
          deal,
          onOkClick: async () => {
            pageLoader.value?.show()
            try {
              const form = operatorDealConfirmModal.value?.getForm();
              await api.dealChangeStatus(id, action, form);
              await loadDeals()
            } catch (e) {
              if (helper.isValidationErrors(e)) {
                for (const item of helper.getValidationErrors(e)) {
                  notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
                }
              }
            } finally {
              pageLoader.value?.hide()
            }
          }
        } as OperatorDealConfirmModalProps);
        return;
      }

      if (action === 'cancel' && (store.getters.isOperator || store.getters.isAdmin )) {
        dealConfirmModal.value?.show({
          title: helper.trans('labels.deal_action_confirmation', {action: helper.trans(`deals.action.${action}`)}),
          okTitle: helper.trans(`deals.action.${action}`),
          cancelTitle: null,
          onOkClick: async () => {
            pageLoader.value?.show()
            try {
              const form = dealConfirmModal.value?.getForm();
              await api.dealChangeStatus(id, action, form);
              await loadDeals()
            } catch (e) {
              if (helper.isValidationErrors(e)) {
                for (const item of helper.getValidationErrors(e)) {
                  notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
                }
              }
            } finally {
              pageLoader.value?.hide()
            }
          }
        } as DealConfirmModalProps);
        return;
      }

      let confirmTitle = helper.trans('labels.deal_action_confirmation', {action: helper.trans(`deals.action.${action}`)});
      if (action === 'accept' && deal.type === Direction.PAY_OUT) {
        const hint = payoutAcceptHint(state.payoutLimit, deal.takerSum.currency);
        if (hint) {
          confirmTitle += '. ' + helper.trans('labels.payin_balance_available_for_accept', hint);
        }
      }

      confirmModal.value?.show({
        title: confirmTitle,
        okTitle: helper.trans(`deals.action.${action}`),
        cancelTitle: null,
        onOkClick: async () => {
          pageLoader.value?.show()
          try {
            await api.dealChangeStatus(id, action);
            await loadDeals()
            if (deal.type === Direction.PAY_OUT) {
              await loadPayoutLimit()
            }
          } catch (e) {
            if (helper.isValidationErrors(e)) {
              for (const item of helper.getValidationErrors(e)) {
                notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
              }
            }
          } finally {
            pageLoader.value?.hide()
          }
        }
      } as ConfirmModalProps);
    }

    const applyFilters = async () => {
      state.page = 1;
      loadDeals()
    }

    const filteredDeals = computed((): ExtendedDealDTO[] => {
      return state.deals.items
    })

    const isExpired = (deal: TraderDealDTO) => {
      if (deal.type === Direction.PAY_OUT && deal.status === DealStatus.NEW) {
        const canceledAt = moment.utc(deal.canceledAt);

        let seconds = canceledAt.unix() * 1000 - state.currentTimestamp;
        if (seconds < 0) {
          return true;
        }
      }

      return false;
    }


    const showMessageLogs = async (deal: TraderDealDTO) => {
        state.logsModalDates = {
          fromDate: dateHelper.format(deal.createdAt),
          toDate: dateHelper.format((moment(deal.createdAt)).utcOffset(0).add(30, 'm').format('YYYY-MM-DD HH:mm:ss') + '+00:00')
        }
        state.logsModalDevice = await api.devicesGet(deal.deviceId!);
    }

    const loadDeals = async () => {
      state.deals.offset = state.deals.limit * (state.page - 1)
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      state.requestDTO.deviceIds = state.devicesFilter.map((value) => value.id)
      state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
      state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)
      pageLoader.value?.show()
      try {
        state.deals = await api.deals(state.deals, state.orderByDTO, {
          ...state.requestDTO,
          fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
          toDate: dateHelper.toUTC(state.requestDTO.toDate),
          updatedFromDate: dateHelper.toUTC(state.requestDTO.updatedFromDate),
        })

        if (store.getters.isAdmin || store.getters.isOperator || store.getters.isTrader || store.getters.isTraderOperator) {
          let deviceIds = [];
          let traderIds = [];
          for (const item of state.deals.items) {
            if (item.deviceId) {
              deviceIds.push(item.deviceId)
            }

            if (item.type === Direction.PAY_IN && item.status === DealStatus.DISPUTE && (store.getters.isAdmin || store.getters.isOperator)) {
              traderIds.push(item.traderId);
            }
          }

          let devices = {} as Dictionary<TraderDeviceDTO>;
          if (deviceIds.length > 0) {
            for (const device of (await api.traderDevices({offset:0, limit: deviceIds.length} as PaginationDTO, {ids: deviceIds})).items) {
              devices[device.id.toString()] = device
            }
          }

          let traderAccounts = {} as AccountDTO[]|any;
          if (traderIds.length > 0) {
            for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {userIds: traderIds})).items) {
              if (!traderAccounts[account.traderId]) {
                traderAccounts[account.traderId] = [];
              }
              traderAccounts[account.traderId].push(account.account)
            }
          }

          for (const item of state.deals.items) {
            if (item.deviceId) {
              item._device = devices[item.deviceId.toString()] ?? null;
            }

            if (item.traderId && item.status === DealStatus.DISPUTE && item.type === Direction.PAY_IN) {
              const traderDealAccount = ((traderAccounts[item.traderId] ?? []) as AccountDTO[]).find(account => account.currency === item.makerSum.currency)
              if (traderDealAccount) {
                let sum = parseFloat(item.makerSum.amount);
                if (item.disputeReasonData && item.disputeReasonData.amount) {
                  let takerSum = parseFloat(item.disputeReasonData.amount)
                  let rate = parseFloat(item.takerSum.amount) / parseFloat(item.makerSum.amount)
                  sum = takerSum / rate;
                }
                if (parseFloat(traderDealAccount.sum.amount) < sum) {
                  item._insufficientSumForDisputeClose = true;
                }
              }
            }
          }

        }

      } finally {
        pageLoader.value?.hide()
      }
    }

    const activeTypeName = computed(() => {
      if (activeTabName.value !== 'active') {
        return null;
      }

      if (!state.requestDTO.types) {
        return null;
      }

      if (state.requestDTO.types.length === 1) {
        return state.requestDTO.types[0];
      }

      return null;
    })

    const activeTabName = computed(() => {
      const selectedStatuses = state.requestDTO.statuses ?? [];

      for (let tab in tabs) {
        const statuses = tabs[tab];

        if (selectedStatuses.length !== statuses.length) {
          continue;
        }

        let allExists = true;
        for (let status of statuses) {
          if (!selectedStatuses.includes(status)) {
            allExists = false;
            break;
          }
        }

        if (!allExists) {
          continue;
        }

        return tab;
      }

      return null;
    })

    const loadPayoutLimit = async () => {
      if (!(store.getters.isTrader || store.getters.isTraderOperator) || store.getters.getUser?.pcId) {
        state.payoutLimit = null;
        return;
      }

      if (state.currentType !== Direction.PAY_OUT) {
        state.payoutLimit = null;
        return;
      }

      try {
        state.payoutLimit = parsePayoutLimitResponse(await api.traderPayoutLimit());
      } catch {
        state.payoutLimit = null;
      }
    }

    const onTypeSelect = async (tab: Direction) => {
      state.currentType = tab;
      onTabSelect('active');

      if (activeTabName.value === 'active') {
        if (state.currentType === Direction.PAY_IN) {
          state.lastUpdateTimeIn = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          state.newActiveDealsCountIn = 0
        }

        if (state.currentType === Direction.PAY_OUT) {
          state.lastUpdateTimeOut = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          state.newActiveDealsCountOut = 0
          await loadPayoutLimit()
        } else {
          state.payoutLimit = null
        }
      }
    }

    const onTabSelect = async (tab: string) => {
      state.orderByDTO = {
        field: 'createdAt',
        direction: 'desc',
      }
      if (tab === 'active') {
        if (state.currentType === Direction.PAY_IN) {
          state.lastUpdateTimeIn = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          state.newActiveDealsCountIn = 0
        }

        if (state.currentType === Direction.PAY_OUT) {
          state.lastUpdateTimeOut = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          state.newActiveDealsCountOut = 0
        }

        state.requestDTO.types = [state.currentType];
        reloadTabActive()
      } else {
        state.requestDTO.types = [];
      }

      if (tab === 'dispute') {
        state.lastUpdateTimeDispute = moment().utc().format('YYYY-MM-DD HH:mm:ss')
        state.newDisputeDealsCountOut = 0
        state.activeDisputeTab = null
        if (store.getters.isAdmin || store.getters.isOperator) {
          state.requestDTO.userRole = state.activeDisputeTab
          state.requestDTO.types = []
        } else {
          state.requestDTO.userRole = null
          state.requestDTO.types = [state.currentType]
        }
      } else {
        state.requestDTO.userRole = null
      }

      state.page = 1;
      state.requestDTO.id = null;
      state.requestDTO.takerId = null;
      state.requestDTO.statuses = tabs[tab]
      state.requestDTO.methods = [];
      state.requestDTO.options = [];
      state.requestDTO.toTakerSum = null
      state.requestDTO.fromTakerSum = null
      state.requestDTO.roundedToTakerSum = null
      state.requestDTO.currencies = [];
      state.requestDTO.fromDate = moment().subtract(1, 'month').format('YYYY-MM-DD 00:00:00');
      state.requestDTO.toDate = null;
      state.requestDTO.requisites = null;
      state.requestDTO.hasDisputeRequest = null
      state.requestDTO.disputePaused = null
      state.requestDTO.onlyMir = null
      state.requestDTO.userRole = null
      state.tradersFilter = [];
      state.devicesFilter = [];
      state.storesFilter = [];
      state.trafficGroupsFilter = [];
      state.requestDTO.trafficGroupsIds = [];
      loadDeals()
    }

    const onDisputeRoleSelect = async (role: null|string) => {
      if (!store.getters.isAdmin && !store.getters.isOperator) {
        return;
      }
      
      state.activeDisputeTab = role;
      state.requestDTO.userRole = role;
      state.page = 1;
      loadDeals()
    }

    const checkNewActiveDeals = async () => {
      state.newActiveDealsCountIn = await api.dealsCount({
        statuses: tabs.active,
        fromDate: state.lastUpdateTimeIn,
        types: [Direction.PAY_IN]
      } as DealRequestDTO)

      state.newActiveDealsCountOut = await api.dealsCount({
        statuses: tabs.active,
        fromDate: state.lastUpdateTimeOut,
        types: [Direction.PAY_OUT]
      } as DealRequestDTO)

      state.newDisputeDealsCountOut = await api.dealsCount({
        statuses: tabs.dispute,
        updatedFromDate: state.lastUpdateTimeDispute,
        types: [] as Direction[]
      } as DealRequestDTO)
    }

    const updateCurrentTime = () => {
      state.currentTimestamp = Date.now()
    }

    const getFormattedCancelTime = (deal: TraderDealDTO): string => {
      const canceledAt = moment.utc(deal.canceledAt);

      let seconds = canceledAt.unix() * 1000 - state.currentTimestamp;
      if (seconds < 0) {
        return '00:00';
      }

      return formatMinutesSeconds(seconds);
    }

    const getFormattedDisputeAutocloseTime = (deal: TraderDealDTO): string => {
      if (!deal.disputeAutocloseAt) {
        return '';
      }

      const disputeAutocloseAt = moment.utc(deal.disputeAutocloseAt);

      let seconds = disputeAutocloseAt.unix() * 1000 - state.currentTimestamp;
      if (seconds < 0) {
        return '00:00';
      }

      return formatMinutesSeconds(seconds);
    }

    const toggleFiltersVisibility = () => {
      state.showFilters = !state.showFilters
    }

    const getMerchantIdToCopy = (deal:ExtendedDealDTO): string => {
      if (!deal.invoiceInternalId) {
        return deal.invoiceId ?? '';
      }

      return deal.invoiceId + ' / ' + deal.invoiceInternalId
    }

    const getAggregatorIdToCopy = (deal:ExtendedDealDTO): string => {
      if (!deal.aggregatorExternalId) {
        return deal.invoiceId ?? '';
      }

      return deal.invoiceId + ' / ' + deal.aggregatorExternalId
    }

    const payOutSupportedMethodsSources = async () => {
      state.payOutDocLink = await api.payOutDocLink();
      if (!state.payOutDocLink) {
        state.payOutSupportedMethodsSources = await api.payOutSupportedMethodsSources();
      }
    }

    const checkNewActiveDealsWithTimeout = async () => {
      if (!state.updateTimeInterval) {
        return;
      }

      try {
        await checkNewActiveDeals();
      } finally {
        if (state.updateTimeInterval) {
          state.updateTimeInterval = setTimeout(checkNewActiveDealsWithTimeout, 10000)
        }
      }
    }

    const onDeviceUpdated = async (deviceDTO: TraderDeviceDTO) => {

      for (const item of state.deals.items) {
        if (!item._device) {
          continue
        }

        if (item._device.id !== deviceDTO.id) {
          continue
        }

        item._device = {...item._device, ...deviceDTO}
      }
    }

    const savePayoutSettings = async () => {
      payOutSettingsModalLoader.value?.show()
      try {
        state.payOutSettings = await api.traderPayoutSettingsUpdate(state.payOutSettings)

      } finally {
        payOutSettingsModalLoader.value?.hide()
      }
      state.payOutSettingsModal = false
    }

    const showPayoutSettings = async () => {
      state.payOutSettingsModal = true
      payOutSettingsModalLoader.value?.show()
      try {
        state.payOutSettings = await api.traderPayoutSettings()

      } finally {
        payOutSettingsModalLoader.value?.hide()
      }
    }

    const reloadPageCondition = () => {
      return store.getters.isTrader && activeTabName.value === 'active' && state.autoRefresh && store.getters.toggleDealsIsAutoReload
    }

    const reloadTabActive = () => {
      if (state.autoRefresh) {
        clearInterval(state.activeTabReloadInterval)
        state.activeTabReloadInterval = window.setInterval(() => {
          if (reloadPageCondition()) {
            loadDeals()
          } else {
            clearInterval(state.activeTabReloadInterval)
          }
        }, 10000);
      }
    }

    const toggleAutoRefresh = () => {
      store.dispatch('toggleDealsIsAutoReload', state.autoRefresh)
      if (state.autoRefresh) {
        reloadTabActive()
      }
    }

    onMounted(async () => {
      if (store.getters.isAdmin || store.getters.isOperator) {
        api.call.providers.all().then((providers) => {
          let byTraderId = {} as Dictionary<ProviderDTO>
          for (const provider of providers) {
            byTraderId[provider.traderId] = provider
          }
          state.providersByTraderId = byTraderId
        })
      }

      payOutSupportedMethodsSources()
      onTabSelect('active');
      state.updateTimeInterval = setTimeout(checkNewActiveDealsWithTimeout, 10000)

      updateCurrentTime()
      state.updateCurrentTimeInterval = setInterval(updateCurrentTime, 1000)

      state.autoRefresh = store.getters.toggleDealsIsAutoReload
    });

    onUnmounted(() => {
      if (state.updateTimeInterval) {
        clearTimeout(state.updateTimeInterval)
        state.updateTimeInterval = null
      }

      if (state.updateCurrentTimeInterval) {
        clearInterval(state.updateCurrentTimeInterval)
      }

      if (state.activeTabReloadInterval) {
        clearInterval(state.activeTabReloadInterval)
      }
    })

    watch(() => state.requestDTO, (newVal) => {
      if (reloadPageCondition()) {
        reloadTabActive()
      } else {
        clearInterval(state.activeTabReloadInterval)
      }
    }, { deep: true });

    const onTraderListUpdate = debounce(() => {
      deviceMultiselect.value?.search('')
    }, 1000);

    const enableOperatorPayInCancelTransferWaiting = computed(() => store.getters.getAppData?.ENABLE_OPERATOR_PAY_IN_DEAL_CANCEL_TRANSFER_WAITING)
    const payOutAmountChangeEnabled = computed(() => store.getters.getAppData?.PAY_OUT_DEAL_AMOUNT_CHANGE_ENABLED)
    const enableOperatorPayInConfirmTransferWaiting = computed(() => store.getters.getAppData?.ENABLE_OPERATOR_PAY_IN_DEAL_CONFIRM_TRANSFER_WAITING)
    const enableDisputeButtonOnActiveDeals = computed(
      () => store.getters.getAppData?.ENABLE_DISPUTE_BUTTON_ON_ACTIVE_DEALS
    )
    const chequeCheckerEnabled = computed(() => !!store.getters.getAppData?.CHEQUE_WALES_CHECKER_ENABLED)
    const canCheckReceipt = computed(() =>
      chequeCheckerEnabled.value
      && (store.getters.isTrader || store.getters.isTraderOperator || store.getters.isAdmin || store.getters.isOperator)
    )

    const isReceiptCheckPending = (deal: TraderDealDTO, attachmentId: number): boolean => {
      return !!state.receiptCheckPending[receiptCheckKey(deal.id, attachmentId)];
    }

    const receiptCheckError = (deal: TraderDealDTO, attachmentId: number): string => {
      return state.receiptCheckErrors[receiptCheckKey(deal.id, attachmentId)] ?? '';
    }

    const receiptCheckTooltip = (deal: TraderDealDTO, attachmentId: number): string | null => {
      const check = findReceiptCheck(deal, attachmentId);
      return check ? dateHelper.format(check.checkedAt) : null;
    }

    const checkReceipt = async (deal: TraderDealDTO, attachmentId: number) => {
      const key = receiptCheckKey(deal.id, attachmentId);
      if (state.receiptCheckPending[key]) {
        return;
      }

      state.receiptCheckPending[key] = true;
      state.receiptCheckErrors[key] = '';
      try {
        upsertReceiptCheck(deal, await api.call.traderDeals.receiptCheck(deal.id, attachmentId));
      } catch (e) {
        if (helper.isValidationErrors(e)) {
          state.receiptCheckErrors[key] = helper.getValidationErrors(e)
            .filter((item) => item.field === 'attachmentId' && item.message)
            .map((item) => item.message)
            .join(' ');
        }
      } finally {
        state.receiptCheckPending[key] = false;
      }
    }

    const disputeButtonOnActiveDealsStatuses = [
      DealStatus.TRANSFER_WAITING,
      DealStatus.TRANSFER_CONFIRMED,
    ]

    const canChangePayOutAmount = (deal: ExtendedDealDTO): boolean => {
      return !!payOutAmountChangeEnabled.value
        && deal.type === Direction.PAY_OUT
        && [DealStatus.NEW, DealStatus.TRANSFER_WAITING, DealStatus.TRANSFER_CONFIRMED].includes(deal.status)
        && !state.providersByTraderId[deal.traderId ?? '']
        && !deal.matchingPayoutDeal
    }

    const showChangeAmount = (deal: ExtendedDealDTO) => {
      changeDealAmountModal.value?.show(deal, async () => {
        await loadDeals()
      })
    }

    const canShowActiveDealDisputeButton = (deal: TraderDealDTO): boolean => {
      return enableDisputeButtonOnActiveDeals.value
        && disputeButtonOnActiveDealsStatuses.includes(deal.status)
    }

    const showStoreRate = computed(() =>
      (!!store.getters.isAdmin || !!store.getters.isOperator)
      && !!store.getters.getAppData?.DEALS_STORE_RATE_ENABLED
    )

    const operatorCompletedPayInDisputeEnabled = computed(
      () => !!store.getters.getAppData?.OPERATOR_COMPLETED_PAY_IN_DISPUTE_ENABLED
    )

    const canShowPayInDisputeButton = (deal: TraderDealDTO): boolean => {
      if (deal.status === DealStatus.CANCELED) {
        return true
      }

      if (deal.status !== DealStatus.COMPLETED) {
        return false
      }

      return store.getters.isAdmin
        || (store.getters.isOperator
          && operatorCompletedPayInDisputeEnabled.value
          && store.getters.hasPermission(UserPermission.DISPUTE_COMPLETED_PAY_IN_DEALS))
    }

    const isVideoRequested = (deal: TraderDealDTO): boolean => {
      return deal.videoRequestedUntil != null && new Date(deal.videoRequestedUntil) > new Date()
    }

    const requestVideo = (deal: TraderDealDTO) => {
      confirmModal.value?.show({
        title: helper.trans('labels.deal_action_confirmation', {action: helper.trans('button.request_video')}),
        okTitle: helper.trans('button.request_video'),
        cancelTitle: null,
        onOkClick: async () => {
          pageLoader.value?.show()
          try {
            await api.call.traderDeals.requestVideo(deal.id);
            notification.notify({type: 'success', title: helper.trans('success.video_request_sent')});
            await loadDeals()
          } catch (e) {
            if (helper.isValidationErrors(e)) {
              for (const item of helper.getValidationErrors(e)) {
                notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
              }
              await loadDeals()
            }
          } finally {
            pageLoader.value?.hide()
          }
        }
      } as ConfirmModalProps);
    }

    const onManualSbpQrDealDetailsUpdated = (updated: TraderDealDTO) => {
      if (state.detailsDeal && state.detailsDeal.id === updated.id) {
        Object.assign(state.detailsDeal, updated)
      }
      const row = state.deals.items.find((d) => d.id === updated.id)
      if (row) {
        Object.assign(row, updated)
      }
    }

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isProvider: computed(() => store.getters.isProvider),
      isTrader: computed(() => store.getters.isTrader),
      isTraderOperator: computed(() => store.getters.isTraderOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTeamLead: computed(() => store.getters.isTeamLead),
      isOperator: computed(() => store.getters.isOperator),
      isReferral: computed(() => store.getters.isReferral),
      showStoreRate,
      enableOperatorPayInCancelTransferWaiting,
      canChangePayOutAmount,
      showChangeAmount,
      changeDealAmountModal,
      enableOperatorPayInConfirmTransferWaiting,
      enableDisputeButtonOnActiveDeals,
      chequeCheckerEnabled,
      canCheckReceipt,
      isPdfAttachment,
      receiptVerdict,
      isReceiptCheckPending,
      receiptCheckError,
      receiptCheckTooltip,
      checkReceipt,
      canShowActiveDealDisputeButton,
      canShowPayInDisputeButton,
      currencyList: computed(() => store.getters["currencyMethods/currencies"]),
      methodList: computed(() => store.getters["currencyMethods/methods"]),
      pageLoader,
      dateHelper,
      helper,
      numberFormatter,
      TransactionType,
      loadDeals,
      onTabSelect,
      onDisputeRoleSelect,
      DealStatus,
      activeTabName,
      changeStatus,
      toggleFiltersVisibility,
      applyFilters,
      tabs,
      api,
      confirmModal,
      dealConfirmModal,
      disputeConfirmModal,
      operatorDealConfirmModal,
      isVideoRequested,
      requestVideo,
      DisputeReason,
      isPayOutReceiptCheck,
      Direction,
      getFormattedCancelTime,
      payoutConfirmModal,
      showMessageLogs,
      typeTabs,
      onTypeSelect,
      activeTypeName,
      deviceMultiselect,
      onTraderListUpdate,
      dealAutocompleting,
      getFormattedDisputeAutocloseTime,
      store,
      UserPermission,
      onDeviceUpdated,
      filteredDeals,
      isExpired,
      savePayoutSettings,
      showPayoutSettings,
      payOutSettingsModalLoader,
      PaymentOption,
      getMerchantIdToCopy,
      getAggregatorIdToCopy,
      suspendDealModal,
      showSuspendDealModal,
      getSuspendDisputeTitle,
      assignTrader,
      assignByUnassigned,
      assignTraderToDealModal,
      toggleAutoRefresh,
      onManualSbpQrDealDetailsUpdated,
    }
  },
  async beforeMount() {
    await useStore().dispatch("currencyMethods/loadList");
  }
})
</script>
